export enum PreviewUpdateStrategy {
  Interval,
  Ws,
  WsApi,
}
